import { render, staticRenderFns } from "./viewAgreement.vue?vue&type=template&id=309349d6&scoped=true&"
import script from "./viewAgreement.vue?vue&type=script&lang=js&"
export * from "./viewAgreement.vue?vue&type=script&lang=js&"
import style0 from "./viewAgreement.vue?vue&type=style&index=0&id=309349d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309349d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309349d6')) {
      api.createRecord('309349d6', component.options)
    } else {
      api.reload('309349d6', component.options)
    }
    module.hot.accept("./viewAgreement.vue?vue&type=template&id=309349d6&scoped=true&", function () {
      api.rerender('309349d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/viewAgreement.vue"
export default component.exports